// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"image-component_uk-open__ynU9K","grecaptcha-badge":"image-component_grecaptcha-badge__HOfw2","placeholder":"image-component_placeholder__xWt2q","placeholder-text":"image-component_placeholder-text__Ip4Jt","svg-class":"image-component_svg-class__hW8Yj"};
    if(module.hot) {
      // 1793877031251
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  